import { useEffect, useState } from "react";

import SectionHero2 from "components/SectionHero/SectionHero2";

import DiscoverMoreSlider from "components/DiscoverMoreSlider";
import SectionSliderProductCard from "components/SectionSliderProductCard";

import SectionGridFeatureItems from "./SectionGridFeatureItems";

import { Product } from "data/data";
import { Helmet } from "react-helmet-async";
import AdsService from "../../app/services/adsService";
import ProductService from "../../app/services/productService";
import { CardCategory3Props } from "../../components/CardCategories/CardCategory3";

function PageHome() {
  const [dataBanners, setDataBanners] = useState<CardCategory3Props[]>([]);
  const [products, setProducts] = useState<Product[]>([]);
  useEffect(() => {
    AdsService.get("banner").then((data) => {
      console.log(data);

      setDataBanners(data);
    });
    ProductService.getProducts().then((data) => {
      setProducts(data);
    });
  }, []);

  return (
    <div className="nc-PageHome relative overflow-hidden">
      <Helmet>
        <title>Roupa</title>
      </Helmet>

      {/* SECTION HERO */}
      <SectionHero2 />

      <div className="mt-24 lg:mt-32">
        <DiscoverMoreSlider data={dataBanners} />
      </div>

      <div className="container relative space-y-24 my-24 lg:space-y-32 lg:my-32">
        {/* SECTION */}
        <SectionSliderProductCard data={products} />

        {/* SECTION */}
        <SectionGridFeatureItems />
      </div>
    </div>
  );
}

export default PageHome;
